import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../services/security.service';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';

export const tokenInteceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const securityService = inject(SecurityService);

  if (
    request.url.includes('/checkSession') ||
    request.url.includes('/getNewSession') ||
    request.url.includes('/setConsultor') ||
    request.url.includes('/app/whatsapp/verifySessionWhatsapp')
  ) {
    return next(request);
  }

  const session = localStorage.getItem('session');

  if (!session) {
    const consultor = localStorage.getItem('consultor');
    if (!consultor) {
      return next(request);
    }

    return securityService.getNewSession(consultor).pipe(
      take(1),
      switchMap((response: any) => {
        localStorage.setItem('session', response.session);
        router.navigate(['/']);
        const newRequest = request.clone({
          setHeaders: {
            token: response.session,
          },
        });
        return next(newRequest);
      }),
      catchError(error => throwError(() => new Error(error)))
    );
  }

  const clonedRequest = request.clone({
    setHeaders: {
      token: session,
    },
  });

  return next(clonedRequest);
};
